/* tslint:disable */

export class HitConclusion {
		ConclusionName: string;
		ConclusionId: number;
		DecisionTableName: string;
		DecisionTableId: number;
		BusinessDataId: number;
		RowId: number;
		Value: string;
		FormattedValue: string;
		RowOrder: number;

}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/HitConclusion.ts